/** Format a count for badge display; values above `max` render as `{max}+`. */
export function formatCounterValue(value: number, max?: number): string {
	const n = Math.max(0, Math.round(value));
	if (max !== undefined && n > max) {
		return `${max}+`;
	}
	return String(n);
}
